import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { TypeAndDescriptionProps } from "./types"

function TypeAndDescription({ description, title }: TypeAndDescriptionProps) {
    const styles = useStyles()

    return (
        <Box sx={styles.container}>
            <Typography variant="subtitle" fontWeight='bold'>{title}</Typography>

            <Typography variant="subtitle">{description}</Typography>
        </Box>
    )
}

export default TypeAndDescription